import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'ngx-prev-button',
    template: `<nb-icon icon="arrow-back-outline"></nb-icon>`,
})
export class PrevButtonComponent {}
